// Console Constants
export const CONSOLE_LIST_REQUEST = "CONSOLE_LIST_REQUEST";
export const CONSOLE_LIST_SUCCESS = "CONSOLE_LIST_SUCCESS";
export const CONSOLE_LIST_FAIL = "CONSOLE_LIST_FAIL";

export const CONSOLE_DETAILS_REQUEST = "CONSOLE_DETAILS_REQUEST";
export const CONSOLE_DETAILS_SUCCESS = "CONSOLE_DETAILS_SUCCESS";
export const CONSOLE_DETAILS_FAIL = "CONSOLE_DETAILS_FAIL";

export const CONSOLE_CREATE_REQUEST = "CONSOLE_CREATE_REQUEST";
export const CONSOLE_CREATE_SUCCESS = "CONSOLE_CREATE_SUCCESS";
export const CONSOLE_CREATE_FAIL = "CONSOLE_CREATE_FAIL";
export const CONSOLE_CREATE_ACKNOWLEDGE = "CONSOLE_CREATE_ACKNOWLEDGE";

export const CONSOLE_DELETE_REQUEST = "CONSOLE_DELETE_REQUEST";
export const CONSOLE_DELETE_SUCCESS = "CONSOLE_DELETE_SUCCESS";
export const CONSOLE_DELETE_FAIL = "CONSOLE_DELETE_FAIL";

// Console Item Constants
export const CONSOLE_ITEM_LIST_REQUEST = "CONSOLE_ITEM_LIST_REQUEST";
export const CONSOLE_ITEM_LIST_SUCCESS = "CONSOLE_ITEM_LIST_SUCCESS";
export const CONSOLE_ITEM_LIST_FAIL = "CONSOLE_ITEM_LIST_FAIL";

export const CONSOLE_ITEM_DETAILS_REQUEST = "CONSOLE_ITEM_DETAILS_REQUEST";
export const CONSOLE_ITEM_DETAILS_SUCCESS = "CONSOLE_ITEM_DETAILS_SUCCESS";
export const CONSOLE_ITEM_DETAILS_FAIL = "CONSOLE_ITEM_DETAILS_FAIL";

export const CONSOLE_ITEM_CREATE_REQUEST = "CONSOLE_ITEM_CREATE_REQUEST";
export const CONSOLE_ITEM_CREATE_SUCCESS = "CONSOLE_ITEM_CREATE_SUCCESS";
export const CONSOLE_ITEM_CREATE_FAIL = "CONSOLE_ITEM_CREATE_FAIL";
export const CONSOLE_ITEM_CREATE_ACKNOWLEDGE = "CONSOLE_ITEM_CREATE_ACKNOWLEDGE";

export const CONSOLE_ITEM_UPDATE_REQUEST = "CONSOLE_ITEM_UPDATE_REQUEST";
export const CONSOLE_ITEM_UPDATE_SUCCESS = "CONSOLE_ITEM_UPDATE_SUCCESS";
export const CONSOLE_ITEM_UPDATE_FAIL = "CONSOLE_ITEM_UPDATE_FAIL";
export const CONSOLE_ITEM_UPDATE_ACKNOWLEDGE = "CONSOLE_ITEM_UPDATE_ACKNOWLEDGE";

export const CONSOLE_ITEM_DELETE_REQUEST = "CONSOLE_ITEM_DELETE_REQUEST";
export const CONSOLE_ITEM_DELETE_SUCCESS = "CONSOLE_ITEM_DELETE_SUCCESS";

// List Item Constants (for managing items within list-type console items)
export const LIST_ITEM_ADD_REQUEST = "LIST_ITEM_ADD_REQUEST";
export const LIST_ITEM_ADD_SUCCESS = "LIST_ITEM_ADD_SUCCESS";
export const LIST_ITEM_ADD_FAIL = "LIST_ITEM_ADD_FAIL";

export const LIST_ITEM_UPDATE_REQUEST = "LIST_ITEM_UPDATE_REQUEST";
export const LIST_ITEM_UPDATE_SUCCESS = "LIST_ITEM_UPDATE_SUCCESS";
export const LIST_ITEM_UPDATE_FAIL = "LIST_ITEM_UPDATE_FAIL";

export const LIST_ITEM_DELETE_REQUEST = "LIST_ITEM_DELETE_REQUEST";
export const LIST_ITEM_DELETE_SUCCESS = "LIST_ITEM_DELETE_SUCCESS";
export const LIST_ITEM_DELETE_FAIL = "LIST_ITEM_DELETE_FAIL";export const CONSOLE_ITEM_DELETE_FAIL = "CONSOLE_ITEM_DELETE_FAIL";